/**
 * Typing an amount on the till's keypad: digits, one decimal point, two
 * decimals at most, ⌫ to take one back. Shared by every place the register
 * asks for a sum of cash.
 */
export const pressAmountKey = (current, key) => {
  if (key === "⌫") return current.slice(0, -1);
  if (key === "." && current.includes(".")) return current;

  const next = `${current}${key}`;
  const [, decimals = ""] = next.split(".");
  return decimals.length > 2 ? current : next;
};

const ARABIC_INDIC = "٠١٢٣٤٥٦٧٨٩";

/**
 * Cleans a typed amount: digits, one decimal separator, two decimals at most.
 *
 * Phone keypads in French and Arabic locales offer "," (or "٫") rather than
 * "." — all of them mean a decimal point here, and Arabic-Indic digits are
 * read as the digits they are. Anything else is dropped.
 */
export const sanitizeAmount = (value) => {
  const cleaned = String(value)
    .replace(/[٠-٩]/g, (digit) => String(ARABIC_INDIC.indexOf(digit)))
    .replace(/[,٫،]/g, ".")
    .replace(/[^0-9.]/g, "");
  const [whole, ...rest] = cleaned.split(".");

  return rest.length > 0 ? `${whole}.${rest.join("").slice(0, 2)}` : whole;
};
